import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { OWNERSHIP_CHANGE_PACKET } from "./apiRoutes";

interface mutateProps {
  ocpId: string;
  data: any;
}

const mutateAddOCPClosingDocument = async ({
  ocpId,
  data,
}: mutateProps) => {
  return await axiosAuth.post(
    `${OWNERSHIP_CHANGE_PACKET}/${ocpId}/documents`,
    data,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

const useAddOCPClosingDocumentMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddOCPClosingDocument,
    ...queryParams,
  });

export default useAddOCPClosingDocumentMutation;
